import { useAuthStore } from "@/stores/authStore"

// 👉 Redirects
export const redirects = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: "/",
    name: "index",
    redirect: to => {
      const user = useCookie("user").value
      const accessToken = useCookie("accessToken").value
      const isLoggedIn = !!(user && accessToken)

      if (!isLoggedIn) {
        return { name: "login", query: to.query }
      }
      if (!user.termsAccepted) {
        return { name: "reglement" }
      }

      return { name: "index", query: to.query }

      // return {name: 'campaign-id', params: {id: CURRENT_YEAR}}
    },
  },
  {
    path: "/table-program",
    name: "table-program",
    redirect: to => {
      const authStore = useAuthStore()

      const isLoggedIn = !!(
        authStore.user &&
        authStore.accessToken &&
        authStore.userAbilityRules
      )

      if (!isLoggedIn) {
        return { name: "login", query: to.query }
      }

      return { name: "table-program" }
    },
  },
]
export const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index.vue"),
  },
]
